module.exports = __webpack_public_path__ + "static/media/Tampere-Caribia-ja-Saimaa_teksti_500x500_elokuu.332b3fba.jpg";